import { z } from 'zod';

export const BlogPostSchema = z.object({
  id: z.string(),
  title: z.string().min(1),
  slug: z.string(),
  description: z.string(),
  content: z.string().min(1),
  author: z.string().min(3),
  date: z.string(),
  image: z.string(),
  tags: z.array(z.string()).default([]),
  published: z.boolean().default(true),
  created_at: z.string(),
  updated_at: z.string(),
  user_id: z.string()
});

export type BlogPost = z.infer<typeof BlogPostSchema>;

export const BlogPostFormSchema = BlogPostSchema.omit({
  id: true,
  slug: true,
  date: true,
  published: true,
  created_at: true,
  updated_at: true,
  user_id: true,
});

export type BlogPostForm = z.infer<typeof BlogPostFormSchema>;